import _regenerator from "/root/workspace/OKEY-front_sY8I/node_modules/_@babel_runtime@7.29.2@@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/OKEY-front_sY8I/node_modules/_@babel_runtime@7.29.2@@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/root/workspace/OKEY-front_sY8I/node_modules/_@babel_runtime@7.29.2@@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.string.trim.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import Breadcrumb from '@/components/Breadcrumb';
import Hamburger from '@/components/Hamburger';
import LangSelect from '@/components/LangSelect';
import NaviSearchDialog from "@/layout/components/navi-search-dialog.vue";
import TopNav from '@/components/TopNav';
import TxtSelect from '@/components/TxtSelect';
export default {
  components: {
    NaviSearchDialog: NaviSearchDialog,
    Breadcrumb: Breadcrumb,
    Hamburger: Hamburger,
    LangSelect: LangSelect,
    TopNav: TopNav,
    TxtSelect: TxtSelect
  },
  computed: _objectSpread({}, mapGetters(['sidebar', 'avatar', 'unreadMsgSize'])),
  mounted: function mounted() {
    this.user = this.$store.state.user.profile;
    this.optionsUtc = [{
      value: 'GMT+0800',
      label: '北京时区'
    }, {
      value: 'GMT+0300',
      label: '土耳其时区'
    }];
    var timeUTC = new Date();
    //打印结果为：Wed Aug 31 2022 10:47:48 GMT+0800 (中国标准时间)
    console.log('VVVVVVVVVV', timeUTC);
    var GMT = (timeUTC + "").split(" ");
    var UTC = GMT[5];
    console.log('AAAAAAAAAAA', UTC.trim());
    //当获取的时区既不是北京，也不是土耳其时区，就默认成“土耳其”时区
    if (UTC.trim() != 'GMT+0800' && UTC.trim() != 'GMT+0300') {
      this.valueUtc = 'GMT+0300';
      return;
    }
    //获取默认时区
    if (localStorage.getItem("utc")) {
      this.valueUtc = localStorage.getItem("utc");
    } else {
      this.valueUtc = UTC.trim();
      localStorage.setItem("utc", this.valueUtc);
    }

    // 默认翻译
    if (localStorage.getItem("isTranslate")) {
      this.valueTranslate = localStorage.getItem("isTranslate");
    } else {
      this.valueTranslate = '0';
      localStorage.setItem("isTranslate", this.valueTranslate);
    }
  },
  data: function data() {
    return {
      activeName: 'profile',
      user: {},
      optionsUtc: [],
      optionsTranslate: [{
        value: '0',
        label: '源文本'
      }, {
        value: '1',
        label: '系统语言'
      }],
      valueUtc: '',
      valueTranslate: ''
    };
  },
  methods: {
    searchAct: function searchAct() {
      console.log("searchAct");
      this.$refs.naviSearchDialogRef.init();
    },
    //选中时区
    clickOptionsUtc: function clickOptionsUtc(item) {
      console.log('WWWWWWWWWWWWWWWW', item);
      localStorage.setItem("utc", item.value);
      console.log(localStorage.getItem("utc"));
      // 刷新当前页面
      window.location.reload();
    },
    // 是否翻译
    clickOptionsTranslate: function clickOptionsTranslate(item) {
      console.log('WWWWWWWWWWWWWWWW', item);
      localStorage.setItem("isTranslate", item.value);
      console.log(localStorage.getItem("isTranslate"));
      // 刷新当前页面
      window.location.reload();
    },
    toggleSideBar: function toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar');
    },
    logout: function logout() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _this.$store.dispatch('tagsView/delAllViews').then(function (_ref) {
                var visitedViews = _ref.visitedViews;
              });
              _context.n = 1;
              return _this.$store.dispatch('user/logout');
            case 1:
              _this.$router.push('/login');
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    toMsg: function toMsg() {
      this.$router.push({
        path: '/MessageCenter'
      });
    }
  }
};